import api from '@/api'

export default {
  all: (filter) => api('get', '/role', filter),
}
